import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import appUtilities from '../utilities/appUtilities'

export function useNav(sessionObj) {
    const [direction, setDirection] = useState(0)
    //  consider they are never out of sync.
    const navigate = useNavigate()
    const { pathname } = useLocation()

    // const idRef = React.useRef('' + (Date.now() % 1000) + `-Nav`)
    // console.log(
    //     `%c${idRef.current} in context pathname is ${pathname}`,
    //     ' color: blue'
    // )

    const pgID = appUtilities.pgIDFromPathname(pathname) // pgID will return 1 for '/'

    useEffect(() => {
        // console.log(
        //     `${idRef.current} in useEffect and direction is ${direction}`
        // )
        // we want to maintain landing page wo a pg1 so we can hv just .../calc/
        // so /calc, /calc/pg2?params, /calc/pg3?more_params

        if (direction) {
            let newPathname = ''

            //  reset
            if (direction === appUtilities.navDirections.reset) {
                newPathname = '/'
            } else {
                newPathname = getPathName()
            }

            let paramString = considerParamString()

            // TODO: 06/30/23 a little ugly here
            //  if returning to start from google maps then reset all the params assoc. w. mapping. - no need for manual
            if (newPathname.includes('resetAll')) {
                paramString = ''
                newPathname = '/'
            }

            // console.log(
            //     `*************** pgID is ${pgID} with a newPathname of ${newPathname}  and paramString is ${paramString}`
            // )

            navigate({
                pathname: newPathname,
                search: paramString,
            })
        }

        function getPathName() {
            if (
                pgID === '1' &&
                direction === appUtilities.navDirections.google
            ) {
                return '/pgGglMap'
            }
            if (
                pgID === '2' &&
                direction === appUtilities.navDirections.previous
            ) {
                return '/'
            }

            if (
                pgID === '3' &&
                direction === appUtilities.navDirections.previous &&
                'zoom' in sessionObj
                // 'map_posts' in sessionObj &&
                // 'map_posts' in sessionObj &&
                // sessionObj.map_posts !== '[]' // TODO: 06/09/23 ensure this is an active sessionObj feature distinguishing it as a Google fence plan
            ) {
                return '/pgGglMap'
            }

            if (pathname.includes('pgGglMap')) {
                if (direction === appUtilities.navDirections.next) {
                    return '/pg3'
                } else {
                    return 'resetAll'
                }
            }

            const newPg = direction + parseInt(pgID, 10)
            return `/pg${newPg}`
        }

        function considerParamString() {
            if (
                direction === appUtilities.navDirections.reset // TODO: 05/11/23 perhaps current never found a role
            ) {
                return ''
            }
            return appUtilities.getParamString(sessionObj)
        }
    }, [direction, sessionObj, navigate, pathname, pgID])

    function pgNav(directn) {
        // console.log('in the pgNav() function and directn is ', directn)
        if (directn === appUtilities.navDirections.current) {
            return
        }
        // @ts-ignore
        setDirection(directn) // chg state to provoke useEffect run
    }

    return [pgID, pgNav]
}
